export default __webpack_public_path__ + "static/media/780.3efc1f21.gif";